/**
 * @generated SignedSource<<f36e944294d026fa58154828d4dd309e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldShowSimilarSoldItems_viewer$data = {
  readonly similarSoldItemsConnection?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "useShouldShowSimilarSoldItems_viewer";
};
export type useShouldShowSimilarSoldItems_viewer$key = {
  readonly " $data"?: useShouldShowSimilarSoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowSimilarSoldItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowSimilarSoldItems_viewer",
  "selections": [
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4
                },
                {
                  "kind": "Variable",
                  "name": "itemId",
                  "variableName": "itemId"
                }
              ],
              "concreteType": "SimilarSoldItemsConnectionConnection",
              "kind": "LinkedField",
              "name": "similarSoldItemsConnection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8198411b37715ef643b2333a3189f941";

export default node;
